import { AppLayout } from '../components/AppLayout';
import { HostRoute } from '../components/ProtectedRoute';

export default [HostRoute, AppLayout];
